"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectArrows = function SelectArrows() {
  return _react2.default.createElement(
    "svg",
    {
      width: "10px",
      height: "17px",
      viewBox: "0 0 10 17",
      className: "quiver-select__arrow"
    },
    _react2.default.createElement(
      "g",
      {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "square"
      },
      _react2.default.createElement(
        "g",
        {
          transform: "translate(-433.000000, -3067.000000)",
          stroke: "#555555",
          strokeWidth: "1.171875"
        },
        _react2.default.createElement(
          "g",
          { transform: "translate(51.000000, 3047.000000)" },
          _react2.default.createElement(
            "g",
            { transform: "translate(383.000000, 21.000000)" },
            _react2.default.createElement("path", {
              d: "M3.75,15.0680144 L3.64937645,15.1686379 L3.48349571, 15.0027572 L0.165880748,11.6851422 L0,11.5192615 L0.331761496, 11.1875 L0.497642244,11.3533807 L3.75,14.6057385 L7.00235776, 11.3533807 L7.1682385,11.1875 L7.5,11.5192615 L7.33411925, 11.6851422 L4.01650429,15.0027572 L3.85062355,15.1686379 L3.75, 15.0680144 Z"
            }),
            _react2.default.createElement("path", {
              d: "M3.75,3.8805144 L3.64937645,3.98113795 L3.48349571, 3.8152572 L0.165880748,0.497642244 L0,0.331761496 L0.331761496, 5.68434189e-13 L0.497642244,0.165880748 L3.75,3.4182385 L7.00235776, 0.165880748 L7.1682385,1.13686838e-13 L7.5,0.331761496 L7.33411925, 0.497642244 L4.01650429,3.8152572 L3.85062355,3.98113795 L3.75, 3.8805144 Z",
              transform: "translate(3.750000, 1.990569) scale(1, -1) translate(-3.750000, -1.990569)"
            })
          )
        )
      )
    )
  );
};

exports.default = SelectArrows;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Select/SelectArrows.js
// module id = 649
// module chunks = 11